import ENVIRONMENT_VAR from "../model/const/env/env.const";
import { I_COOKIE_STORAGE_TOKENS } from "../model/interface/cookies/cookies_storage_tokens.interface";
import { Cookies } from "react-cookie";

export const getTokenUser = () => {
  const instanceCookie = new Cookies();
  const cookies = instanceCookie.get(ENVIRONMENT_VAR.COOKIE_TOKEN);
  if (cookies) return cookies as I_COOKIE_STORAGE_TOKENS;
  else return null;
};
